// Module
var code = "<div class=\"question-check-row\"> <div class=\"title-holder\"> <mycrm-checkbox label=\"{{vm.label}}\" value=\"vm.value\" key=\"vm.key\" on-change=\"vm.onChange({ value })\"></mycrm-checkbox> </div> <div class=\"content-holder\"> {{vm.content}} <edit-icon ng-if=\"vm.showEdit\" ng-click=\"vm.onEdit()\"></edit-icon> </div> </div> ";
// Exports
module.exports = code;